import React from 'react'

const RecordingsProcessing = ({eplStatus, recordingsCount}) => {
  const message = eplStatus === 'Interviewed' && recordingsCount === 0
    ? 'Recordings are being processed, may take couple of hours.'
    : 'No recordings found for this EPL.'

    return (
    <div className="recordings-processing">{message}</div>
  )
}

export default RecordingsProcessing